// @flow
import React, { Fragment, useState, useCallback } from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import * as cssTele2 from './Accordion.module.css';
import * as cssComviq from './AccordionComviq.module.css';
import { useSelector } from 'react-redux';
import { isComviqCustomer } from '../../helpers/customerTypeHelpers';

type PropType = {
  data: Array<string>,
};

const InfoAccordion = ({ data }: PropType) => {
  const [active, setActiveIndex] = useState({ activeIndex: -1 });

  const customerType = useSelector((state) => state.app.customerType);
  const isComviq = isComviqCustomer(customerType);
  const css = isComviq ? cssComviq : cssTele2;
  const toggleAccordion = useCallback(
    (e, titleProps) => {
      const { index } = titleProps;
      const { activeIndex } = active;
      const newIndex = activeIndex === index ? -1 : index;
      setActiveIndex({ activeIndex: newIndex });
    },
    [active]
  );
  if (!customerType) return <></>;
  return (
    <Fragment>
      <Accordion styled fluid className={css.accordion}>
        {data.map((item, i) => (
          <Fragment key={i}>
            <Accordion.Title active={active.activeIndex === i} index={i} onClick={toggleAccordion}>
              <div className={isComviq ? css.label : undefined}>
                {item.title}
                <Icon name={`expand ${active.activeIndex === i ? 'less' : 'more'}`} />
              </div>
            </Accordion.Title>
            <Accordion.Content active={active.activeIndex === i}>
              <div className={isComviq && css.container}>
                {item.text}
                {item.asterixFootnote && <span className={css.asterix}>{item.asterixFootnote}</span>}
              </div>
            </Accordion.Content>
          </Fragment>
        ))}
      </Accordion>
    </Fragment>
  );
};

export default React.memo(InfoAccordion);
